import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';

/** Job service (polling/sessionStorage/download) da Ficha Cadastral PJ. */
@Injectable({ providedIn: 'root' })
export class FichaCadastralPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'ficha-cadastral-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.fichaCadastralPj;
}
